import React from 'react';
import Layout from 'components/layout';
import ContentPage from 'components/content-pages';
import { ContentPageProps } from 'types/content-pages';
import { handleBlogContentPageServerSideProps } from 'utils/content-pages';

import type { GetServerSidePropsContext } from 'next';
import { TenantTypes } from '@tenants';
import { HandlerType } from 'utils/next/shared-getServerSideProps';
import { createGetServerSideProps } from 'utils/next/shared-getServerSideProps';
import { TenantIds } from '@tenants';
import { FeaturesType } from 'contexts';
import HeadData from 'components/head-data';
import HubspotForm from 'components/hubspot-form';
import FormPage from 'components/form-page';
import { FORM_ID, HUBSPOT_FORM_SRC, PORTAL_ID } from 'pages/insights';
import styles from '../style.module.scss';


export const handler: HandlerType<ContentPageProps> = async (context: GetServerSidePropsContext, _features?: FeaturesType, tenant?: TenantTypes) => {
  const slug = context.params?.slug;
  if (!slug) {
    return {
      notFound: true,
    };
  }

  return await handleBlogContentPageServerSideProps(tenant.id, [
    TenantIds.EXP_COMMERCIAL,
    TenantIds.EXP_COMMERCIAL_CA,
  ], `/${slug}`);
};

export const getServerSideProps = createGetServerSideProps(handler);


export default function DynamicInsightsBlogPage(props: ContentPageProps) {
  return (
    <Layout showMobileBottomNav={false}>
      <HeadData data={{ title: 'Insights - eXp Commercial' }} />
      <ContentPage {...props} />
      <FormPage
        className={styles['container']}
        formContainerClassname={styles['form-container']}
        title="Stay Informed"
        description="Get the latest commercial insights and success stories delivered to your inbox."
        formContent={<HubspotForm className="hs-form-frame" src={HUBSPOT_FORM_SRC} formId={FORM_ID} portalId={PORTAL_ID} region="na1" />}
      />
    </Layout>
  );
}
